import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import CartBar from "../cart/CartBar";
import { CartContext } from "../cart/CartContext";
import { QuoteContext } from "../quote/QuoteContext";
import QuoteBar from "../quote/QuoteBar";

const HeaderMobileCart = () => {
  const { cart } = useContext(CartContext);
  const { quoteItems } = useContext(QuoteContext);
  const [showCart, setShowCart] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [quoteCount, setQuoteCount] = useState(0);
  const [showQuote, setShowQuote] = useState(false);
  useEffect(() => {
    if (Array.isArray(quoteItems)) {
      setQuoteCount(quoteItems.length);
    } else if (quoteItems && typeof quoteItems === "object") {
      setQuoteCount(Object.keys(quoteItems).length);
    } else {
      setQuoteCount(0);
    }
  }, [quoteItems]);

  useEffect(() => {
    if (cart) {
      const safeCart = Array.isArray(cart) ? cart : Object.values(cart);
      const totalItems = safeCart.reduce((acc, item) => acc + item.quantity, 0);
      setCartCount(totalItems);
    } else {
      setCartCount(0);
    }
  }, [cart]);

  return (
    <>
     
      <a className="quote" title="Request Quote"onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowQuote((prev) => !prev);
          setShowCart(false);
        }}>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <g>
                <rect fill="none" height="24" width="24"/>
                <path d="M14,2H6C4.9,2,4.01,2.9,4.01,4L4,20c0,1.1,0.89,2,1.99,2H18c1.1,0,2-0.9,2-2V8L14,2z M15,12h-4v1h3c0.55,0,1,0.45,1,1v3 c0,0.55-0.45,1-1,1h-1v1h-2v-1H9v-2h4v-1h-3c-0.55,0-1-0.45-1-1v-3c0-0.55,0.45-1,1-1h1V9h2v1h2V12z M13,8V3.5L17.5,8H13z"/>
              </g>
            </svg>
            <span className="label">Quote</span>
            <span className="badge">{quoteCount}</span>
            
          </a>
          <a className="cart" title="Cart" onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowCart((prev) => !prev);
            setShowQuote(false);
          }}>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
            </svg>
            <span className="label">Cart</span>
            <span className="badge">{cartCount}</span>
          </a>
           {/* CartBar controlled by cart icon */}
      <CartBar showCart={showCart} onClose={() => setShowCart(false)} />

      {/* QuoteBar controlled by quote icon */}
      <QuoteBar isOpen={showQuote} onClose={() => setShowQuote(false)} />
    </>
  );
};

export default HeaderMobileCart;
